import get from 'lodash/get'
export const getById = (state, id) => {
  return get(state, `triggerRules.byId.${id}`, null)
}

export const hasChanges = (state, id) => {
  const rule = getById(state, id)
  return !!(rule && rule.hasChanges)
}
